export class MeterRepaymentVendor {
  id: number = 0;
  name: string = '';
}

export class MeterRepayment {
  id: number = 0;
  repaymentPeriod: number | undefined;
  vendors: MeterRepaymentVendor[] = [];
}
